/**
 * HubSpot Form Initialization
 *
 * This script initializes HubSpot forms by finding placeholders with
 * data-form-id attributes and creating forms in those locations.
 */

(function() {
    'use strict';

    /**
     * Find and initialize all HubSpot form placeholders
     */
    function initHubSpotForms() {
        // Select all elements with class + data-form-id
        var placeholders = document.querySelectorAll(
            '.hubspot-form-placeholder[data-form-id]'
        );

        console.log('Found ' + placeholders.length + ' HubSpot form placeholders');

        placeholders.forEach(function(placeholder) {
            var formId = placeholder.getAttribute('data-form-id');

            // Ensure the placeholder has an ID for targeting
            if (!placeholder.id) {
                placeholder.id = 'hubspot-form-' + formId;
            }

            try {
                console.log('Creating HubSpot form: ' + formId);

                // Create the form using HubSpot's API
                window.hbspt.forms.create({
                    region: 'na1',
                    portalId: window.hsVars.portal_id,  // Uses the global you already set
                    formId: formId,
                    target: '#' + placeholder.id,
                    onFormReady: function($form) {
                        console.log('Form loaded successfully: ' + formId);
                        // Add a class to the form once it's loaded
                        placeholder.classList.add('form-loaded');
                    },
                    onFormSubmit: function($form) {
                        console.log('Form submitted: ' + formId);
                        // You can add custom tracking or other logic here
                    }
                });
            } catch (e) {
                console.error('HubSpot init error for form', formId, e);
                placeholder.classList.add('form-error');

                // Add a fallback error message
                if (placeholder.childNodes.length === 0) {
                    var errorMessage = document.createElement('div');
                    errorMessage.className = 'hubspot-form-error';
                    errorMessage.innerHTML = 'There was a problem loading this form. Please try again later.';
                    placeholder.appendChild(errorMessage);
                }
            }
        });
    }

    /**
     * Wait for both DOM and HubSpot script to be ready
     */
    function waitForReady() {
        if (
            document.readyState !== 'loading' &&
            typeof window.hbspt !== 'undefined' &&
            typeof window.hbspt.forms !== 'undefined'
        ) {
            console.log('HubSpot forms library loaded, initializing forms...');
            initHubSpotForms();
        } else {
            console.log('Waiting for HubSpot forms library...');
            setTimeout(waitForReady, 100);
        }
    }

    // Kick it off as soon as possible
    waitForReady();

    // Also set up DOMContentLoaded listener as a fallback
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            if (typeof window.hbspt === 'undefined' || typeof window.hbspt.forms === 'undefined') {
                console.log('DOM loaded but HubSpot not yet available, waiting...');
                waitForReady();
            }
        });
    }
})();
